import { STORE_EXCHANGE } from 'app/constants/LOCALKEYS'
import useSWR from 'swr'
import API from '../../../utils/api'
import { useToken } from '../auth/token'
import { getPersistData } from '../persist'

const KEY = STORE_EXCHANGE

let swrData: any = []

let lastcall: any = null

export function useExchangeStore(initData?: any, reset?: boolean) {
	const { data: token } = useToken()
	const { data, mutate } = useSWR<any>(
		KEY,
		async () => {
			if (swrData.length > 0) {
				if (lastcall) {
					const diff =
						new Date().getTime() - new Date(lastcall).getTime()
					if (diff < 1000 * 60 * 60) {
						return swrData
					}
				} else {
					return swrData
				}
			}
			const result = await API.get(
				'/exchanges?id=0&isall=1',
				token + '',
				{},
				false
			)
			if (result?.result) {
				swrData = result?.result
			} else {
				swrData = []
			}

			lastcall = new Date().getTime()

			return swrData
		},
		{
			dedupingInterval: 1000 * 60 * 60,
			revalidateOnFocus: false,
			revalidateOnReconnect: false,
			refreshWhenHidden: false,
			refreshWhenOffline: false,
			shouldRetryOnError: false,
		}
	)

	return {
		data,
		EPs: data,
		EPsAll: data,
		mutate: (value?: any) => {
			if (value !== undefined) swrData = value
			return mutate()
		},
	}
}
